import MuiTypography from '@mui/material/Typography';
import { Stack } from '@mui/system';
import dayjs from 'dayjs';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import _ from 'lodash';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import { Status } from '../../booking/conf/Data.conf';
import RectangleChip from '../../../components/common/RectangleChip.component';
import depot from '../index';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import { API } from '../../operations/api';
import { ServiceOptions } from './Data.conf';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { Checkbox, Grid, Chip, Tooltip } from '@mui/material';
import Autocomplete from '../../../components/form/components/Autocomplete.component';
import {
  StatusOperationBookingType,
  StatusOperationType,
  StatusBilling,
} from '../../operations/conf/Data.conf';
import TextField from '../../../components/form/components/TextField.component';
import SelectCustom from '../../../components/form/components/SelectCustom.component';
import TemplateDelete from '../../../pages/templates/Delete.template';
import DuplicateTemplate from '../../../pages/duplicate/Duplicate.template';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: [
      { by: 'requested_date', direction: 'desc' },
      { by: 'requested_hour', direction: 'asc' },
    ],
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'checkbox_select',
      key: 'checkbox_select',
      sort_key: '',
      sortable: false,
      label: '',
      checkbox: true,
      width: 40,
      selectable: true,
    },
    {
      id: 'attributes.duplicate',
      key: 'duplicate',
      label: '',
      width: 1,
      checkbox: true,
    },
    {
      id: 'attributes.id_yacht.data',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'Yacht Name',
      width: '200px',
    },
    {
      id: 'attributes.status_operation_booking_id',
      key: 'status_operation_booking_id',
      sort_key: 'status_operation_booking',
      sortable: true,
      label: 'Operational Status',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.id_service.data.attributes.service',
      key: 'service',
      sort_key: 'id_service.service',
      sortable: true,
      label: 'Service',
      width: '180px',
    },
    {
      id: 'attributes.OC_fees_id',
      key: 'OC_fees_id',
      sort_key: 'OC_fees',
      sortable: true,
      label: 'Notes',
      width: 300,
      checkbox: true,
    },
    {
      id: 'attributes.requested_date',
      key: 'requested_date',
      sort_key: 'requested_date',
      sortable: true,
      label: 'Delivery Date',
      width: '160px',
    },
    {
      id: 'attributes.id_marina.data.attributes.marina',
      key: 'id_marina',
      sort_key: 'id_marina.marina',
      sortable: true,
      label: 'Location',
      width: 160,
    },
    {
      id: 'attributes.OC_BC_number_id',
      key: 'OC_BC_number_id',
      sort_key: 'OC_BC_number',
      sortable: true,
      label: 'Sales Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.OF_BF_number_id',
      key: 'OF_BF_number_id',
      sort_key: 'OF_BF_number',
      sortable: true,
      label: 'Purchase Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.status_billing_id',
      key: 'status_billing_id',
      sort_key: 'status_billing',
      sortable: true,
      label: 'Billing Status',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.billing_notes_id',
      key: 'billing_notes_id',
      sort_key: 'billing_notes',
      sortable: true,
      label: 'Billing Notes',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes',
      key: 'delete',
      sortable: false,
      label: '',
      width: '0px',
      checkbox: true,
    },
  ],
  render: {
    formatHead: (key, value, { isChecked, indeterminate }) => {
      switch (key) {
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              indeterminate={indeterminate}
            />
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick, isChecked) => {
      switch (key) {
        case 'status_operation_booking_id':
          const color = _.find(
            Status,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_operation_booking?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...depot,
                query: {
                  ...depot.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_operation_booking: value?.status_operation_booking,
              }}
              name={'status_operation_booking'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_operation_booking'
                    name='status_operation_booking'
                    label='Operational Status'
                    options={StatusOperationBookingType}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_operation_booking ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_operation_booking}
                    backgroundColor={color?.hex}
                    color='#fff'
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );
        case 'yacht_name': {
          const attendance =
            value?.attributes?.id_attendance?.data?.[0]?.attributes ||
            value?.attributes?.id_attendance?.data?.attributes ||
            value?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes;
          const provenence =
            attendance?.id_provenence_list?.data?.attributes?.provenence?.data
              ?.attributes?.provenence ||
            value?.attributes?.provenence;
          const mexalCode = attendance?.mexal_code || '-';
          const mexalResearchName = attendance?.mexal_research_name || '-';
          const mexalTooltip = [mexalCode, mexalResearchName]
            .filter((item) => item && item !== '-')
            .join(' - ');

          return (
            <Tooltip title={mexalTooltip || ''}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                spacing={1}
              >
                <Stack direction={'column'} spacing={0.5}>
                  <MuiTypography
                    variant='body1'
                    sx={{ fontWeight: 'bold' }}
                    onClick={onClick}
                  >
                    {value?.attributes?.yacht_name || '-'}
                  </MuiTypography>
                  {provenence && (
                    <MuiTypography
                      variant='caption'
                      color='text.secondary'
                      onClick={onClick}
                    >
                      {provenence}
                    </MuiTypography>
                  )}
                  <Chip
                    label={`#${value?.id || '-'}`}
                    size="small"
                    sx={{ width: 'fit-content', alignSelf: 'flex-start' }}
                  />
                </Stack>
              </Stack>
            </Tooltip>
          );
        }
        case 'date_out':
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value || '-'}
              </MuiTypography>
            </Stack>
          );

        // case 'operation_date':
        case 'requested_date': {
          return (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <CalendarIcon color='action' />
              <MuiTypography
                sx={{ fontWeight: 'bold', height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {value ? dayjs(value).format('DD-MM-YYYY') : '-'}
              </MuiTypography>
            </Stack>
          );
        }
        case 'id_user_in_charge':
        case 'name': {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <PersonIcon color='action' fontSize='small' />
              <MuiTypography
                sx={{ height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {`${value?.name} ${value?.surname}`}
              </MuiTypography>
            </Stack>
          ) : (
            '-'
          );
        }
        case 'status_operation_BC_id':
          return (
            <TableCellEdit
              module={{
                ...depot,
                query: {
                  ...depot.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_operation_BC: value?.status_operation_BC,
              }}
              name={'status_operation_BC'}
              form={
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    id='status_operation_BC'
                    name='status_operation_BC'
                    label='BC'
                    value={
                      value?.status_operation_BC
                        ? { label: value?.status_operation_BC }
                        : null
                    }
                    options={StatusOperationType}
                  />
                </Grid>
              }
            >
              {value?.status_operation_BC === 'OPEN' ? (
                <CancelIcon color='error' />
              ) : value?.status_operation_BC === 'CLOSED' ? (
                <CheckCircleIcon color='success' />
              ) : (
                <DoNotDisturbIcon color='disabled' />
              )}
            </TableCellEdit>
          );
        case 'OC_BC_number_id':
          return (
            <TableCellEdit
              module={{
                ...depot,
                query: {
                  ...depot.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_BC_number: value?.OC_BC_number }}
              value={value}
              name={'OC_BC_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_BC_number'
                    name='OC_BC_number'
                    label='Sales Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_BC_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );

        case 'OF_BF_number_id':
          return (
            <TableCellEdit
              module={{
                ...depot,
                query: {
                  ...depot.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OF_BF_number: value?.OF_BF_number }}
              value={value}
              name={'OF_BF_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OF_BF_number'
                    name='OF_BF_number'
                    label='Purchase Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OF_BF_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'OC_fees_id':
          return (
            <TableCellEdit
              module={{
                ...depot,
                query: {
                  ...depot.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_fees: value?.OC_fees }}
              value={value}
              name={'OC_fees'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_fees'
                    name='OC_fees'
                    label='Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_fees || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'service':
          const serviceColors = _.find(
            ServiceOptions,
            (item) => item?.id === value
          )?.color;
          return value ? (
            <RectangleChip
              value={value}
              width={'auto'}
              backgroundColor={serviceColors}
              color='#fff'
            />
          ) : (
            '-'
          );

        case 'billing_notes_id':
          return (
            <TableCellEdit
              module={{
                ...depot,
                query: {
                  ...depot.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ billing_notes: value?.billing_notes }}
              value={value}
              name={'billing_notes'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='billing_notes'
                    name='billing_notes'
                    label='Billing Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.billing_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'status_billing_id':
          const colorBilling = _.find(
            StatusBilling,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_billing?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...depot,
                query: {
                  ...depot.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_billing: value?.status_billing,
              }}
              name={'status_billing'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_billing'
                    name='status_billing'
                    label='Billing Status'
                    options={StatusBilling}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_billing ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_billing}
                    backgroundColor={colorBilling?.hex}
                    color={colorBilling?.textHex}
                    width={150}
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              disabled={onClick ? false : true}
            />
          );
        case 'delete':
          return (
            <TemplateDelete module={depot} idDelete={value?.id} isIcon>
              <Box mt={1}>
                The list of items and linked logbooks will be deleted.
              </Box>
            </TemplateDelete>
          );
        case 'duplicate':
          return <DuplicateTemplate module={depot} data={value} isIcon />;
        default:
          return (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
